import { Canvas } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";

import { GridContainerBlock, GridItemBlock, HeadingBlock, LinkBlock } from "..";
import BasePreview from "../base";

function OptoutFeedbackPreview({ ...props }) {
  return <BasePreview {...props}>
    <div>
      <Canvas
        id="grid-container"
        is={GridContainerBlock}
        custom={{ name: 'Grid' }}
        properties={{ layoutType: 'grid', grid: { columns: 1, rows: 2, height: 'fitcontent', gap: { all: '6-predefined' } }, size: { width: 'w-full' } }} >
        <Canvas
          is={GridItemBlock}
          custom={{ name: 'Heading' }}
          properties={{ grid: { itemColumn: 1 } }} >
          <Canvas
            is={HeadingBlock}
            properties={{ content: "<h1>You have been optout.</h1>", textAlign: { horizontal: 'center' }, size: { width: 'w-full' }, fontWeight: 'font-bold' }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Link' }} >
          <Canvas
            is={LinkBlock}
            properties={{ content: "Visit our site", url: "/", textAlign: { horizontal: 'center' }, size: { width: 'w-full' }, textColor: 'blue-500', className: 'cursor-pointer' }} />
        </Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

export default define('optout-feedback', OptoutFeedbackPreview)
  .property(prop.stylePattern('optout-feedback'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.layout())
  .defaultProps({
    size: { width: 'w-full' },
  })
  .build()
